import { Table, TableCell, TableRow } from '@fukuri-admins/ui/common';
import React from 'react';
import styles from './styles.module.scss';

type Props = {
  rows: {
    no?: number;
    user_name: string;
    email: string;
    accessed_at: string;
  }[];
  onSort: (column: string) => void;
};

export const AccessLogTableContent: React.FC<Props> = ({ rows, onSort }) => {
  if (!rows || rows.length === 0) {
    return <div className={styles.emptyTable}>データなし</div>;
  }

  return (
    <Table
      fixedHeader
      maxHeight='min(720px, 90vh)'
      headers={[
        { label: 'No', sortable: true, onSort: () => onSort('no') },
        { label: '名前', sortable: true, onSort: () => onSort('user_name') },
        { label: 'メール', sortable: true, onSort: () => onSort('email') },
        { label: 'ログイン日時', sortable: true, onSort: () => onSort('accessed_at') },
      ]}
    >
      {rows.map((row, index) => (
        <TableRow key={index}>
          <TableCell>{row.no}</TableCell>
          <TableCell>{row.user_name}</TableCell>
          <TableCell>{row.email}</TableCell>
          <TableCell>{row.accessed_at}</TableCell>
        </TableRow>
      ))}
    </Table>
  );
};
